<template>
  <div>
    <Modal v-model="isShowModal" :title="title" @on-cancel="hide('formValidate')" :mask-closable="false"
           width="600">

      <Card :bordered="false" :style="{marginBottom:'10px'}">
        <!--表格数据-->
        <Table :columns="columns" :data="data" size="small" :stripe="true" :loading="isTableLoading">
          <template slot-scope="{ row, index }" slot="changeType">
            <span v-if="row.changeType == 1">积分赠送</span>
            <span v-if="row.changeType == 2">购买减少</span>
            <span v-if="row.changeType == 3">退单返还</span>
          </template>
          <template slot-scope="{ row, index }" slot="changeAmount">
            <span v-if="row.changeType == 1">+{{ row.changeAmount }}</span>
            <span v-if="row.changeType == 2">-{{ row.changeAmount }}</span>
            <span v-if="row.changeType == 3">+{{ row.changeAmount }}</span>
          </template>
        </Table>
        <!--分页-->
        <div class="hs-page">
          <Page :total="total" show-sizer show-total transfer @on-change="changePage"
                @on-page-size-change="changePageSize"/>
        </div>
      </Card>

      <!-- 重写对话框底部按钮 -->
      <div slot="footer">
        <Button @click="hide('formValidate')">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowModal: false,
      loadingBtn: false,
      title: '积分记录',
      total: 0,
      params: {
        page: 1,
        rows: 10,
        userId: ''
      },
      isTableLoading: false,
      // 表格列
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: '类型',
          minWidth: 100,
          slot: 'changeType'
        },
        {
          title: '标题',
          minWidth: 120,
          key: 'title'
        },
        {
          title: '积分',
          minWidth: 50,
          slot: 'changeAmount'
        },
        {
          title: '变更时间',
          minWidth: 150,
          key: 'createTime'
        }
      ],
      // 表格数据
      data: [],
    }
  },
  methods: {
    // 显示模态框
    show(row) {
      this.isShowModal = true;
      this.params.userId = row.userId
      this.findList(row);
    },
    // 查询投诉及意见详情
    findList(row) {
      this.$Spin.show();
      this.axios.post('/user/findUserIntegral', this.params).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        this.isTableLoading = false;
        if (res.status == 200) {
          this.total = res.data.total;
          this.data = res.data.rows;
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询用户列表接口报错',
            duration: 0
          });
        }
      })
    },
    inited(viewer) {
      this.$viewer = viewer
    },
    // 关闭模态框
    hide(name) {
      this.isShowModal = false;
      // this.$refs[name].resetFields();
    },
    // 改变页数
    changePage(e) {
      this.params.page = e;
      this.findList();
    },
    // 改变页容量
    changePageSize(e) {
      this.params.rows = e;
      this.findList();
    },
  },
}
</script>

<style scoped>
.jw-images-row {
  display: flex;
  align-items: center;
}

.jw-image {
  width: 150px;
  height: 150px;
  margin-right: 10px;
}
</style>
